import { SCRIPT_URL } from '../../_constants/qualie';

const injectScriptIntoDocumentHead = (src, defer = true) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.defer = defer;
    document.head.appendChild(script);
};

const loadQualieTestimonials = (inView) => {
    const qualie = document.getElementById('reel-reviews-embed-widget');

    if (!!window.IntersectionObserver && qualie) {
        const options = {
            threshold: 0.2,
        };
        const observer = new IntersectionObserver((entries, observe) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    injectScriptIntoDocumentHead(SCRIPT_URL);
                    observe.unobserve(qualie);
                }
            });
        }, options);
        observer.observe(qualie);
    }
    inView && inView();
};

export default loadQualieTestimonials;
